<template>
    <select v-model="value">
        <slot />
    </select>
</template>

<script setup>
import { useField } from 'vee-validate'

const props = defineProps({
    name: String,
    modelValue: String
})

// The `name` is returned in a function because we want to make sure it stays reactive
// If the name changes you want `useField` to be able to pick it up
const { value, errorMessage } = useField(() => props.name, undefined, {
    syncVModel: true
})
</script>
